import React from "react";
import './Legal.css';
import './Home';
import Facebok from '../assets/images/Facebok.png';
import Wasa from '../assets/images/Wasa.png';
import insta from '../assets/images/insta.png';
import Telefono from '../assets/images/Telefono.png';
import Ubi from '../assets/images/Ubi.png';
import Email34 from '../assets/images/Correo.png';
import RedesFondo from '../assets/images/Red-Neuronal.png';

function Legal() {
  return (
    <>
    <div className="legal-container">
      <h2 className="legal-title">Aviso legal</h2>
    </div>

 <div className="legal-text-container">
        <p className="legal-text">
         <br></br>
         <p>En GRUPO IATEKZA, nos comprometemos a proteger y respetar tu privacidad. Esta Política de Privacidad tiene como objetivo informarte sobre cómo recopilamos, utilizamos, almacenamos y protegemos tus datos personales cuando utilizas nuestro sitio web sí envías mensajes o formularios de contacto.<br></br>
         </p><br></br>
         <span className="negrita-destacada-legal">1. Información que recopilamos:</span><br></br>
     <p>    Recopilamos la siguiente información cuando interactúas con nuestro sitio web, ya sea a través de formularios de contacto, mensajes o cualquier otro medio disponible:<br></br>
<span className="negrita-destacada-guion">•</span> Datos de contacto: nombre, dirección de correo electrónico, número de teléfono.<br></br>
<span className="negrita-destacada-guion">•</span> Datos de formularios: cualquier otro dato que decidas proporcionar al completar un formulario (por ejemplo, comentarios, solicitudes, etc.).<br></br>
<span className="negrita-destacada-guion">•</span> Datos de navegación: información sobre tu dispositivo, dirección IP, tipo de navegador, y datos sobre cómo interactúas con nuestro sitio web a través de cookies y tecnologías similares.<br></br>
</p><br></br>
<span className="negrita-destacada-legal">2. ¿Cómo utilizamos tus datos?</span><br></br>
<p>Utilizamos la información que recopilamos para los siguientes fines:<br></br>
<span className="negrita-destacada-guion">•</span> Proporcionar y mejorar el servicio: para responder a tus consultas, procesar tus solicitudes y mejorar nuestra página web.<br></br>
<span className="negrita-destacada-guion">•</span> Comunicaciones: para enviarte información relevante sobre tu consulta o solicitud, actualizaciones, noticias, y otros mensajes relacionados con los servicios que ofrecemos.<br></br>
<span className="negrita-destacada-guion">•</span> Seguridad: para proteger nuestros servicios y la información de nuestros usuarios.<br></br>
</p><br></br>
<span className="negrita-destacada-legal">3. ¿Cómo protegemos tus datos?</span><br></br>
<p>Implementamos medidas de seguridad razonables para proteger tus datos personales contra el acceso no autorizado, la alteración, divulgación o destrucción. Sin embargo, debes tener en cuenta que ninguna transmisión de datos por Internet es completamente segura y no podemos garantizar la seguridad absoluta.<br></br>
</p><br></br>
<span className="negrita-destacada-legal">4. ¿Compartimos tus datos con terceros?</span><br></br>
<p>No venderemos, alquilaremos ni compartiremos tus datos personales con terceros sin tu consentimiento explícito, salvo en las siguientes circunstancias:<br></br>
<span className="negrita-destacada-guion">•</span> Proveedores de servicios: podemos compartir tu información con proveedores de servicios que nos ayuden a operar nuestro sitio web o procesar tus solicitudes, siempre que estos proveedores estén obligados a mantener la confidencialidad de los datos.<br></br>
<span className="negrita-destacada-guion">•</span> Cumplimiento legal: podemos divulgar tus datos si es requerido por la ley o para proteger nuestros derechos, propiedad o seguridad.<br>
</br><br></br></p>
<span className="negrita-destacada-legal">5. Uso de cookies</span><br></br>
<p>Nuestro sitio web utiliza cookies para mejorar tu experiencia de navegación. Las cookies son pequeños archivos que se almacenan en tu dispositivo para recordar tu interacción con el sitio web. Puedes controlar el uso de cookies a través de la configuración de tu navegador. Para más información sobre cómo utilizamos las cookies, puedes consultar nuestra Política de Cookies.<br></br>
</p><br></br>
<span className="negrita-destacada-legal">6. Derechos sobre tus datos personales</span><br></br>
<p><span className="negrita-destacada-guion">•</span> Dependiendo de tu ubicación y las leyes aplicables, puedes tener los siguientes derechos sobre tus datos personales:<br></br>
<span className="negrita-destacada-guion">•</span> Acceso: derecho a acceder a los datos personales que tenemos sobre ti.<br></br>
<span className="negrita-destacada-guion">•</span> Rectificación: derecho a corregir cualquier información incorrecta o incompleta.<br></br>
<span className="negrita-destacada-guion">•</span> Supresión: derecho a solicitar la eliminación de tus datos personales, siempre que no exista una obligación legal que nos impida hacerlo.<br></br>
<span className="negrita-destacada-guion">•</span> Limitación del tratamiento: derecho a solicitar que se limite el tratamiento de tus datos personales.<br></br>
<span className="negrita-destacada-guion">•</span> Oposición: derecho a oponerte al procesamiento de tus datos personales en determinadas circunstancias.<br></br>
<span className="negrita-destacada-guion">•</span> Portabilidad de datos: derecho a recibir tus datos personales en un formato estructurado y de uso común, y a transferirlos a otro responsable del tratamiento.<br></br>
</p><br></br>
<p>Para ejercer cualquiera de estos derechos, por favor, contáctanos a través de los medios indicados al final de esta política.<br>
</br></p><br></br>
<span className="negrita-destacada-legal">7. Enlaces a sitios web de terceros</span><br></br>
<p>Nuestro sitio web puede contener enlaces a otros sitios web. No somos responsables de las prácticas de privacidad ni del contenido de estos sitios. Te recomendamos que leas sus políticas de privacidad antes de proporcionar cualquier dato personal.<br></br>
</p><br></br>
<span className="negrita-destacada-legal">8. Transferencias internacionales de datos</span><br></br>
<p>Si tus datos personales son transferidos a un país fuera de tu jurisdicción, tomaremos las medidas necesarias para asegurarnos de que se protejan adecuadamente conforme a esta política de privacidad y las leyes aplicables de protección de datos.<br></br>
</p><br></br>
<span className="negrita-destacada-legal">9. Cambios en la política de privacidad</span><br></br>
<p>Nos reservamos el derecho de actualizar o modificar esta Política de Privacidad en cualquier momento. Cualquier cambio será publicado en esta página, indicando la fecha de la última actualización. Te recomendamos que revises periódicamente esta política para estar informado sobre cómo protegemos tu información.<br></br>
</p><br></br>
<span className="negrita-destacada-legal">10. Contacto</span><br></br>
<p>Si tienes alguna pregunta o inquietud sobre esta Política de Privacidad o sobre cómo manejamos tus datos personales, puedes ponerte en contacto con nosotros a través de los siguientes medios:<br></br>
<span className="negrita-destacada-guion">•</span> Correo electrónico: contacto@gmail.com<br></br>
<span className="negrita-destacada-guion">•</span> Teléfono: 55 0000 0000</p>

<span className="negrita-destacada-actualiza">Última actualización: 23 de Julio 2025</span><br></br>
        </p>
      </div>

<div className="contacto-footer-nuevo">
  <div className="footer-contenido-nuevo">
    {/* Fondo completo con redes */}
  <img src={RedesFondo} alt="Fondo redes" className="redes-fondo-completa" />
    {/* Columna 1: Contacto */}
    <div className="footer-columna-nueva">
  <h4>CONTACTO GRUPO IATEKZA</h4>

  <div className="footer-item">
    <img src={Ubi} alt="Ubi" className="footer-icono" />
    <p>Circon 5, Colonia El Pedregal de <br /> Atizapán, Estado de México, C.P. 52948.</p>
  </div>

  <div className="footer-item">
    <img src={Telefono} alt="Teléfono" className="footer-icono" />
    <p>+52 55 5335 5810</p>
  </div>

  <div className="footer-item">
    <img src={Email34} alt="Correo" className="footer-icono" />
    <p>ventas@iatekza.com</p>
  </div>
</div>


    {/* Columna 2: Servicios */}
    <div className="footer-columna-nueva">
      <h4>Conoce nuestros servicios</h4>
      <ul>
        <li><a href="/">• IAutomatiza CFDI</a></li>
        <li><a href="/Facturacion">• Facturación Electronica</a></li>
        <li><a href="/Comercializacion">• Infraestructura TI</a></li>
        {/* Servicio Consultoria ERP LIBRA colum 2*/}
        <li><a href="/Consultoria">• Asesoria Empresarial</a></li>
        {/* Servicio Sistemas colum 2*/}
        <li><a href="/Sistemas">• Soluciones Tecnologícas</a></li>
      </ul>
      <div className="iconos-redes-nuevos">
        <a href="https://www.facebook.com/profile.php?id=61577085653032&locale=es_LA/" target="_blank" rel="noopener noreferrer">
          <img src={Facebok} alt="Facebook" />
        </a>
        <a href="https://api.whatsapp.com/send?phone=5215567786252&text=Hola, me gustaría más información acerca de:" target="_blank" rel="noopener noreferrer">
          <img src={Wasa} alt="WhatsApp" />
        </a>
        <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer">
          <img src={insta} alt="Instagram" />
        </a>
      </div>
    </div>

    {/* Columna 3: Información general */}
    <div className="footer-columna-nueva">
      <h4>Información General</h4>
      <ul>
        <li><a href="/CasosExito">Casos de Éxito</a></li>
        <li><a href="/Nosotros">Sobre nosotros</a></li>
        <li><a href="/Legal">Aviso Legal</a></li>
      </ul>
    </div>
  </div>

  <div className="footer-bottom-nuevo">
    <p>© Grupo IAtekza 2025 – Todos los derechos reservados</p>
  </div>
</div>
 


    </>
    
  );
}

export default Legal;
